module.exports = __webpack_public_path__ + "static/adv1-1493c9c7cb8396c431de643b1de3bd5b.png";